module.exports = __webpack_public_path__ + "static/media/borderlessLogo-02.68e510e7.png";